import React from "react";
import { API } from "@/lib/api";
import { Download, X } from "lucide-react";

export default function QrModal({ product, onClose }) {
  if (!product) return null;
  const pngUrl = `${API}/products/${product.id}/qr.png`;
  const pdfUrl = `${API}/products/${product.id}/qr.pdf`;

  return (
    <div
      className="fixed inset-0 z-50 bg-[#1A1A18]/40 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="qr-modal-backdrop"
    >
      <div
        className="bg-white border border-[#E8E6DF] rounded-sm w-full max-w-md p-6 hed-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-2">
          <div>
            <div className="hed-overline">Product QR · scan & learn</div>
            <h3 className="font-serif text-2xl mt-1">{product.name}</h3>
            <div className="text-xs text-[#5C5C54] mt-0.5">CODE · {product.code}</div>
          </div>
          <button
            onClick={onClose}
            className="text-[#5C5C54] hover:text-[#1A1A18]"
            data-testid="qr-modal-close"
          >
            <X size={18} strokeWidth={1.5} />
          </button>
        </div>
        <div className="bg-[#FAFAF8] border border-[#E8E6DF] p-6 my-4 flex items-center justify-center">
          <img
            data-testid="qr-modal-image"
            src={pngUrl}
            alt="Product QR"
            className="w-64 h-64 object-contain"
          />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <a
            data-testid="qr-download-png"
            href={pngUrl}
            download={`HEDA-${product.code}-QR.png`}
            className="inline-flex items-center justify-center gap-2 border border-[#E8E6DF] hover:bg-[#F2F0EA] px-4 py-2.5 rounded-sm text-sm transition-colors"
          >
            <Download size={14} strokeWidth={1.5} /> Download PNG
          </a>
          <a
            data-testid="qr-download-pdf"
            href={pdfUrl}
            className="inline-flex items-center justify-center gap-2 bg-[#1A1A18] text-white px-4 py-2.5 rounded-sm text-sm hover:bg-[#2a2a26] transition-colors"
          >
            <Download size={14} strokeWidth={1.5} /> Branded PDF
          </a>
        </div>
      </div>
    </div>
  );
}
